<template>
  <div class="lowCarbon_container">
    <div :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }">
      <img :src="getContainerBG" v-if="backgroundMask"/>
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBG == 'typeStrong'"></div>
    <left-part :modelType="modelType" v-if="!isSetting && refreshTag"></left-part>
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag"></right-part>
    <setting style="z-index: 2" :modelType="modelType" v-if="isSetting"></setting>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";

import { mapState, mapGetters } from "vuex";

import { ref, shallowRef, computed, provide } from "vue";
import { CamLeapFunc } from "@/assets/js/unity3D/index.js";
import {dateFormat} from "utils/tools";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { leftPart, rightPart, setting },
  props: {},
  data() {
    //这里存放数据
    return {
      pageInfo: 'LowCarbonMod.vue',
      computedName: '低碳首页组件',
     backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "LowCarbonMod",
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
      eventData: {},
      curMapType: "",
    };
  },
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" +
          this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
    mapTypeVal() {
      return this.$store.state.mapType;
    },
    isVisit() {
      return this.$store.state.isVisit
    }
  },
  provide: function () {
    return {
      getEventData: computed(() => this.eventData),
      updateEventData: this.updateEventData,
    };
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal;
      },
      deep: true,
    },
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance.computedName,
          sourcePage: instance.pageInfo,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    flyTo() {
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth;
        let view =
          mapViews[`mapViews_${this.customerId}`] &&
          mapViews[`mapViews_${this.customerId}`].dutyMod;
        if (view && view.length) {
          earth.camera.flyTo(view[0], view[1], view[2], view[3]);
        } else {
          g_bme3dManager.flyAround();
        }
      }
    },
    isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== "3D") return;
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        this.bme3dManagerLoaded = true;
        this.flyTo();
      } else {
        let that = this;
        if (that.loadedTimer) {
          clearTimeout(that.loadedTimer);
        }
        that.loadedTimer = setTimeout(function () {
          that.isBme3dManagerLoaded();
        }, 100);
      }
    },
    updateEventData(item) {
      this.eventData = item;
    },
    reset() {
      this.modelType = "LowCarbonMod";
      this.refreshTag = true;
      this.eventData = {};
    },
    reload() {
      let that = this;
      this.refreshTag = false;
      this.$nextTick(function () {
        that.reset();
        this.refreshTag = true;
      });
    },
    /**
     * 判断是否是参观模式 针对南通中天参观模式做特殊处理
     */
    initVisit() {
      if (this.isVisit) {
        this.$nextTick(() => {
            $(".version_right_bar").css("visibility", "hidden");
            $(".version_left_bar_visit").css("display", "block");
          })
      }
    },
    async isVisitFun() {
      let isCustomerVersionUrl = CONFIG.requestName + this.$apiOpt.isCustomerVersion
      let isCustomerVersionResult = await this.$apiUtils.get(isCustomerVersionUrl, {
        customerId: this.customerId
      }).then(res => {
        if (res === 'customer') {
          this.$store.dispatch("setIsVisit", {
            value: true,
          })
          this.initVisit()
        } else {
          this.$store.dispatch("setIsVisit", {
            value: false,
          })
        }
      }).catch(() => {
        
      })
      return Promise.resolve()
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.curMapType = this.$store.state.mapType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
 async mounted() {
    this.curBG = this.$store.state.curBG;
    $(".version_left_bar").addClass("yejinLogo");

    setTimeout(() => {
      CamLeapFunc();
    }, 500);
    if(bmeConfig.isVisitedMod) {
      await this.isVisitFun()
    }
  },
  unmounted() {
    $(".version_left_bar").removeClass("yejinLogo");
    if (this.isVisit) {
      $(".version_right_bar").css("visibility", "visible");
      $(".version_left_bar_visit").css("display", "none");
    }
  },
  activated() {},
  deactivated() {},
  beforeUnmount() {},
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
};
</script>
<style scoped>
.lowCarbon_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>
